/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2217
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.Msg = undefined
exports.Msg = {
  MATH_ADDITION_SYMBOL: "+",
  MATH_SUBTRACTION_SYMBOL: "-",
  MATH_DIVISION_SYMBOL: "÷",
  MATH_MULTIPLICATION_SYMBOL: "×",
  MATH_POWER_SYMBOL: "^",
  MATH_TRIG_SIN: "sin",
  MATH_TRIG_COS: "cos",
  MATH_TRIG_TAN: "tan",
  MATH_TRIG_ASIN: "asin",
  MATH_TRIG_ACOS: "acos",
  MATH_TRIG_ATAN: "atan",
  START_GROUP_TAG: "事件",
  OUTPUT_GROUP_TAG: "输出",
  EXECUTION_GROUP_TAG: "执行",
  BLOCK_GROUP: "积木分组",
  RELEASE_GROUP: "解除分组",
  HIDE_BLOCK_STACK: "隐藏积木块",
  SHOW_BLOCK_STACK: "取消隐藏积木块"
}
